import React from "react";

interface Props {
	avatar: string;
}

const ConversationAvatar = ({ avatar }: Props) => {
	return (
		<div className="intercom-avatar">
			<img alt="intercom_avatar" src={avatar ?? "/graphics/user-avatar.svg"} />
		</div>
	);
};
export default ConversationAvatar;
